module.exports = __webpack_public_path__ + "img/aztecEmpire.c879f06d.jpg";